import Script from "next/script";
import { useEffect, useState } from "react";
import cx from 'classnames'
import { trackError } from '../../utils/error-tracking'

type IUnit = { type: string; selectorId?: string }

const Playwire = () => {
	// Disable ads during Cypress tests
	if (typeof window !== 'undefined' && (window as unknown as { Cypress?: boolean }).Cypress) {
		return null;
	}

	return (
		<>
			<PlaywireVideo />
			<Script
				id="playwire"
				src="https://cdn.intergient.com/ramp.js"
				strategy="lazyOnload"
			/>
		</>
	);
};

const PlaywireVideo = () => {
	const [open, setOpen] = useState(true)
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		window['ramp'] = {
			mode: "ramp",
			config: "https://config.playwire.com/1024584/v2/websites/73415/banner.json",
			passiveMode: true,
			onReady: function () {
				const lb = document.querySelector("#first-leaderboard");
				const pwUnits: IUnit[] = lb
					? [
						{
							selectorId: "first-leaderboard",
							type: "sky_atf",
						},
					]
					: [];

				// pwUnits.push({ type: "bottom_rail" })
				pwUnits.push({ type: "trendi_video" });
				setVisible(true)

				return Promise.resolve()
					.then(() => {
						return window['ramp'].destroyUnits("all");
					})
					.then(() => {
						return window['ramp'].addUnits(pwUnits)
					})
					.then(() => {
						setOpen(true)
						return window['ramp'].displayUnits();
					})
					.catch((e) => {
						// catch errors
						// ramp.displayUnits();
						trackError("Ramp error", e);
					});
			}
		};
	}, [setOpen])

	return <div className={cx("video-element-container", { open, hidden: !visible })}>
		<div className="video-element-close" onClick={() => setOpen(!open)} aria-label={`${open ? 'Close' : 'Open'} Video Player`}><span>×</span></div>
		<div id="video-element" />
	</div>
}

export default Playwire;
